export const navMenu = [
  {
    id: 1,
    menuTitle: "홈",
    url: "/home",
  },
  {
    id: 2,
    menuTitle: "운송매칭",
    url: "/matchlist",
  },
  {
    id: 3,
    menuTitle: "내운송정보",
    // url: "/task-chargeTransfer",
    url: "/myDrive",
  },
  {
    id: 4,
    menuTitle: "더보기",
    url: "/more",
  },
];
